// extracted by mini-css-extract-plugin
export default {"PropertyInventoryScreen":"CausesManage_PropertyInventoryScreen__PcVj9","LoadingPlaceholder":"CausesManage_LoadingPlaceholder__-hysW"};